<template>
  <div class="order-desc">
    <div v-if='loadFailed' class='failed'>
      <button type='button' class='btn' @click='getData'>再読み込み</button>
    </div>
    <div v-if='order'>    
      <div class="order-desc__title">
        この案件の作業を開始する場合は <br>
        「作業開始」を押してください。
      </div>
      <div class="order-desc__content" v-html='order.description'></div>
      <div class="floating-actions">
        <button @click='gotoSteps' class='btn'>
          作業開始
        </button>
        <button @click='gotoQuoteSteps' class='btn btn-orange'>
          見積り{{order.quote_exists ? '確認' : '開始'}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      order: null,
      loadFailed: false,
    }
  },
  methods: {
    gotoSteps: function() {
      var toSteps = () => {
        this.$router.push({name: 'orderSteps', params: this.$route.params});
      };
      var back = () => {
        this.$router.push({name: 'orders'});
      };

      if (this.order.invoice_amount > 0) {
        this.$$.alert({
          message: "紹介料が調整済みの案件です。アプリで報告すると一度、調整がリセットされますので、報告後、もう一度調整希望をお願いします",
          action: toSteps,
          actionText: "はい",
          cancelAction: back,
          cancelText: 'いいえ',
        })
      }
      else {
        toSteps();
      }
    },
    gotoQuoteSteps: function() {
      this.$router.push({name: 'orderQuoteSteps', params: this.$route.params});
    },
    getData: function() {
      this.loadFailed = false;
      this.$api.getOrderDetails(this.$route.params.id)
      .then((res) => {
        this.order = res.data.data;
        this.order.description = 
          this.order.description.replace(/\n/g, "<br />");
      })
      .catch(() => {
        this.loadFailed = true;
      })
    }
  },
  mounted: function() {
    this.$$.context({
      previous: '戻る',
      previousRouteName: 'orders',
      title: '作業詳細',
      showAccountControl: true
    });

    this.getData();
  },
}
</script>

<style lang='scss'>
.order-desc {
  .failed {
    padding-top: 120px;
    text-align: center;
  }
  padding: 16px;
  overflow: auto;
  height: 100%;
  &__title {
    font-size: 18px;
  }
  &__content {
    margin-top: 16px;
    margin-bottom: 100px;
    padding: 16px;
    line-height: 1.5;
    border: 1px solid #ccc;
    -webkit-overflow-scrolling: touch;
  }
  
  .quote {
    background-color: #fd7e14;
  }
}
</style>